import script from "./AboutBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutBlock.vue?vue&type=script&setup=true&lang=js"

import "./AboutBlock.vue?vue&type=style&index=0&id=4943b836&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4943b836"]])

export default __exports__